import { render, staticRenderFns } from "./gate.vue?vue&type=template&id=564b02db&scoped=true&"
import script from "./gate.vue?vue&type=script&lang=js&"
export * from "./gate.vue?vue&type=script&lang=js&"
import style0 from "./gate.vue?vue&type=style&index=0&id=564b02db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564b02db",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('564b02db')) {
      api.createRecord('564b02db', component.options)
    } else {
      api.reload('564b02db', component.options)
    }
    module.hot.accept("./gate.vue?vue&type=template&id=564b02db&scoped=true&", function () {
      api.rerender('564b02db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/setting/gate.vue"
export default component.exports